import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineAbilityConfig} from '../system/defineAbilityConfig';
import {ONLY_ON_PRIMARY_LOCALE} from './localization';
import {WHEN_NOT_IN_OPTIMIZE_MODE} from './optimization';

export const canAccessApps = defineAbilityConfig([
  {
    userTypes: {
      authorizedInDesigner: true,
      unauthorized: false,
    },
    branches: {
      main: true,
      branch: true,
    },
    siteModes: {design: true},
    workflows: {canvas: true},
    localization: ONLY_ON_PRIMARY_LOCALE,
    optimization: WHEN_NOT_IN_OPTIMIZE_MODE,
  },
  {
    // Campaign Build Mode - allow apps panel in edit mode
    abilities: {isInCampaignBuildMode: true},
    workflows: {canvas: true},
  },
  {
    // Page Build Mode - allow apps panel when FF is enabled (narrow rollout)
    abilities: {isInPageBuildMode: true},
    workflows: {canvas: true},
    featureFlags: {[FEATURE_FLAGS.APP_MODES_BUILD_MODE]: true},
  },
] as const);
